<script>
    import "./pagination.css";
    export let current = 0;
    export let count = 0;
    export let setCurrentPage;
    const siblingCount = 1;
    const DOTS = '...';
    let paginationRange = [];

    const changeBackPage = () => {
        const newValue = current - 1;
        if (newValue > 0) setCurrentPage(newValue);
    };

    const changePage = (pageNumber) => {
        if (current !== pageNumber) setCurrentPage(pageNumber);
    };

    const changeNextPage = () => {
        const newValue = current + 1;
        if (newValue <= count) setCurrentPage(newValue);
    };

    $: {
        const totalPageNumbers = 5;
        if (totalPageNumbers >= count) {
            paginationRange = range(1, count);
        } else {
            const leftSiblingIndex = Math.max(current - siblingCount, 1);
            const rightSiblingIndex = Math.min(current + siblingCount, count);
            const shouldShowLeftDots = leftSiblingIndex > 2;
            const shouldShowRightDots = rightSiblingIndex < count - 2;
            const firstPageIndex = 1;
            const lastPageIndex = count;
            if (!shouldShowLeftDots && shouldShowRightDots) {
                const leftItemCount = 3 + 2 * siblingCount;
                const leftRange = range(1, leftItemCount);
            paginationRange = [...leftRange, DOTS, count];
            } else if (shouldShowLeftDots && !shouldShowRightDots) {
                const rightItemCount = 3 + 2 * siblingCount;
                const rightRange = range(count - rightItemCount + 1, count);
                paginationRange = [firstPageIndex, DOTS, ...rightRange];
            } else if (shouldShowLeftDots && shouldShowRightDots) {
                const middleRange = range(leftSiblingIndex, rightSiblingIndex);
                paginationRange = [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
            } else {
                paginationRange = paginationRange = range(firstPageIndex, lastPageIndex);
            }
        }
    }

    const range = (start, end) => {
        const length = end - start + 1;
        return Array.from({ length }, (_, idx) => idx + start);
    };
</script>
<div class="pages flex flex-text-center">
    <div class="pagination flex items-center">
        <div class="previous pagination-item flex items-center" on:click={changeBackPage}>
            <img src="./images/ic_prev_arrow.svg" alt="back-arrow"/>
            <div class="pagination-text">PREVIOUS</div>
        </div>
        {#each paginationRange as pageNumber}
            {#if pageNumber === DOTS}
                <div class="pagination-item">
                    {DOTS}
                </div>
            {:else}
                <div class="pagination-item" class:active={pageNumber === current} on:click={() => changePage(pageNumber)}>
                    {pageNumber}
                </div>
            {/if}
        {/each}
        <div class="next btn-gradient-background flex items-center pagination-item" on:click={changeNextPage}>
            <div class="pagination-text">NEXT</div>
            <img src="./images/ic_next_arrow.svg" alt="back-next"/>
        </div>
    </div>
</div>